function parseNestedData(value) {
  if (!value) return {};
  if (typeof value === "object") return value;
  if (typeof value !== "string") return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function normalizePushData(rawData) {
  const root = rawData && typeof rawData === "object" ? rawData : {};
  const nested = parseNestedData(root.data);
  return { ...root, ...nested };
}

export function resolvePushNavigation(rawData) {
  const data = normalizePushData(rawData);
  const type = String(data.type || data.kind || "").toLowerCase();
  const groupId = String(data.groupId || data.groupid || "").trim();
  const chatId = String(data.chatId || data.chatid || "").trim();

  if (type === "stay_access_request") {
    const alertId = String(data.alertId || data.alertid || "").trim();
    return {
      panel: "alertsAdmin",
      props: alertId
        ? { selectedAlert: { id: alertId, category: "criticos" } }
        : {},
    };
  }

  const eventId = String(data.eventId || data.eventid || "").trim();
  if (type === "event_invite_request") {
    return eventId ? { panel: "eventManage", props: { eventId } } : null;
  }
  if (type === "event_invite_request_decision") {
    return eventId ? { panel: "eventDetails", props: { eventId } } : null;
  }

  if (groupId || type === "group_chat_message" || type === "group") {
    return groupId ? { panel: "groupChat", props: { groupId } } : null;
  }

  if (chatId || type === "direct_chat_message" || type === "direct") {
    return chatId ? { panel: "directChat", props: { chatId } } : null;
  }

  if (data.openPanel === "guide") {
    return {
      panel: "guide",
      props: {
        requestId: data.requestId || "",
        requestType: data.requestType || "",
      },
    };
  }

  if (!eventId) return null;
  const opensGallery =
    type === "participation_gallery_new_photo" || String(data.openGallery) === "1";
  return opensGallery
    ? {
        panel: "trail",
        props: {
          openParticipationGallery: {
            eventId,
            eventName: data.eventName || data.eventname || "",
          },
        },
      }
    : { panel: "eventDetails", props: { eventId } };
}
